"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import CTA from "./components/cta";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import ServicesComponent from "./components/services";

const ZadaraCloudPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PrivateCloudTabs />
      <Intro />
      <CTA />
      <FeaturesComponent />
      <ServicesComponent />
      <Faqs />
    </PageLayout>
  );
};

export default ZadaraCloudPage;
